module.exports = __webpack_public_path__ + "static/img/kr-lottery-h5.42bfab77.png";